import MarketplaceRootView from "./MarketplaceRootView";

import "./MarketplaceRootView.scss";

export { MarketplaceRootView };
